'use strict';

var Backbone = require('backbone'),
  utilities = require('../../js/utilities'),
  cacheCookieHelper = require('../../components/CacheCookieHelper/CacheCookieHelper'),
  config = require('../../js/config'),
  cookies = require('js-cookie'),

  SORT_OPTIONS = {
    lastModified: 'lastModified',
    dateCreatedOldest: 'dateCreatedOldest',
    dateCreatedNewest: 'dateCreatedNewest',
    nameAZ: 'nameAZ',
    nameZA: 'nameZA'
  },
  SORT_QUERY = {
    modified: 'modified',
    created: 'created',
    name: 'name'
  },
  ORDER_QUERY = {
    asc: 'asc',
    desc: 'desc'
  },

  MyProjectListingView = Backbone.View.extend({

    events: {
      'click .MyProjectsListing-howTo-close': 'hide',
      'change .MyProjectsListing-intro .SearchControls-select': 'updateSorting'
    },

    initialize: function() {

      this.$howTo = this.$('.MyProjectsListing-howTo');
      this.$searchSelect = this.$('.MyProjectsListing-intro .SearchControls-select');

      if (!cookies.get(config.cookies.myProjectsListingHowTo)) {
        utilities.animateToAuto(this.$howTo, 'height');
        this.$howTo.addClass(config.classes.isVisible);
      }
    },

    hide: function(e) {
      utilities.animateFromAuto(this.$howTo, 'height');
      this.$howTo.removeClass(config.classes.isVisible);
      cookies.set(config.cookies.myProjectsListingHowTo, 'hidden');
      if (cacheCookieHelper) {
        cacheCookieHelper.setCacheCookie();
      }
      if (e) { e.preventDefault(); }
    },

    updateSorting: function(e) {
      var sort = 'modified';
      var order = 'desc';
      switch (this.$searchSelect.val()) {
        case SORT_OPTIONS.dateCreatedOldest:
          sort = SORT_QUERY.created;
          order = ORDER_QUERY.asc;
          break;
        case SORT_OPTIONS.dateCreatedNewest:
          sort = SORT_QUERY.created;
          order = ORDER_QUERY.desc;
          break;
        case SORT_OPTIONS.nameAZ:
          sort = SORT_QUERY.name;
          order = ORDER_QUERY.asc;
          break;
        case SORT_OPTIONS.nameZA:
          sort = SORT_QUERY.name;
          order = ORDER_QUERY.desc;
          break;
        default:
      }
      window.location.search = utilities.serialize({
        sort: sort,
        order: order
      });
      if (e) { e.preventDefault(); }
    }

  });

module.exports = MyProjectListingView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/MyProjectListingView.js